module.exports = __webpack_public_path__ + "static/media/lvjian-yipinhuayuan.6a7c6f9a.png";